import * as React from "preact";
import { FunctionComponent } from "preact";
import cx from "classnames";
import PaginationLink from "../PaginationLink";

export interface IPagination {
  page?: number;
  pageSize?: number;
}

export interface IPaginationProps extends IPagination {
  totalItems: number;
  className?: string;
  handleChangePage?: (page: number) => void;
}

const Pagination: FunctionComponent<IPaginationProps> = ({
  page = 1,
  pageSize = 20,
  totalItems,
  className,
  handleChangePage,
}) => {
  const totalPages = Math.ceil(totalItems / pageSize);
  if (totalPages < 2) {
    return null;
  }

  const prevPage = page > 1 ? page - 1 : null;
  const nextPage = page < totalPages ? page + 1 : null;

  // Show only a small number of pages at a time, i.e. a maximum of 5 (current page plus up to 2 pages on either side of it)
  const paginationLimit = 2;
  const allPageNumbers = [...Array(totalPages)].map((_, i) => i + 1); // Build all pages array
  let restrictedPages;
  const upperLimit = page + paginationLimit;
  if (totalPages > 3 && page > 2) {
    restrictedPages = allPageNumbers.slice(page - paginationLimit - 1, upperLimit); // -1 for index
  } else {
    restrictedPages = allPageNumbers.slice(0, upperLimit);
  }

  return (
    <nav className={cx("pagination", className)}>
      <div className="pagination__inner">
        {/* Previous page link */}
        {prevPage && (
          <PaginationLink
            page={prevPage}
            handleChangePage={handleChangePage}
            type="prev"
            title="Previous Page"
            rel="prev"
          />
        )}

        {/* All restricted pages including the "active" one */}
        {restrictedPages.map((pg) => {
          return (
            <PaginationLink
              page={pg}
              key={pg}
              handleChangePage={handleChangePage}
              type="page"
              title={`Page ${pg}`}
              current={pg === page}
            />
          );
        })}

        {/* Next page link */}
        {nextPage && (
          <PaginationLink
            page={nextPage}
            handleChangePage={handleChangePage}
            type="next"
            title="Next Page"
            rel="next"
          />
        )}
      </div>
    </nav>
  );
};

export default Pagination;
